import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ addressId, acceptanceClientId }) =>
  request.delete(
    `Acceptance/delete_record_by_unilateral_transfer`,
    { addressId, acceptanceClientId },
    'Не удалось отменить одностороннюю передачу',
    'Error'
  );

export const useCancelUnilateral = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error') {
        if (typeof options?.onSuccess === 'function') {
          options.onSuccess(data, variables);
        }
      }
    },
  });
